import React from 'react';
import { useNavigate } from 'react-router-dom';
import { usePharmacy } from '../pharmacyContext';
import { PHARMACY_COPY } from '../pharmacyCopy';
import Icon from '../../common/Icons';
import { PharmacyPageHeader } from '../ui';
import StockTable from '../components/StockTable';
import { useInventoryRoutes } from '../components/inventoryUi';

const copy = PHARMACY_COPY.STOCK_CENTRAL;

export default function PharmacyCentralStockPage() {
  const { centralSite } = usePharmacy();
  const navigate = useNavigate();
  const routes = useInventoryRoutes();

  return (
    <div className="cp-stock-page">
      <PharmacyPageHeader
        badge={copy.BADGE}
        title={copy.TITLE}
        description={copy.DESC}
        actions={
          <button
            type="button"
            className="cp-btn cp-btn--ghost"
            onClick={() => navigate(routes.LIST)}
          >
            <Icon name="clipboard-list" size={15} aria-hidden />
            {copy.CTA_INVENTORY}
          </button>
        }
      />

      {centralSite ? (
        <StockTable
          siteId={centralSite.id}
          allowAdjust
          siteLabel={`${copy.SITE_BADGE} · ${centralSite.name}`}
          stockLocation="MAIN"
        />
      ) : (
        <div className="cp-empty-state cp-card">
          <span className="cp-empty-state__icon" aria-hidden>
            <Icon name="warehouse" size={28} />
          </span>
          <h3 className="cp-empty-state__title">{copy.NO_CENTRAL}</h3>
        </div>
      )}
    </div>
  );
}
